import script from "./PosBatchReduce.vue?vue&type=script&lang=ts&setup=true"
export * from "./PosBatchReduce.vue?vue&type=script&lang=ts&setup=true"

import "./PosBatchReduce.vue?vue&type=style&index=0&id=30be2c31&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30be2c31"]])

export default __exports__